import React from 'react'
import './DotSnippet.css'

const DotHtmlSnippet = () => (
  <>
    <pre>
      <code>
        <span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>dots-container</span>
        <span className='cln'>"</span>
        <span className='cln'> id="</span>
        <span className='cn'>dotsContainer</span>
        <span className='cln'>"</span>&gt;<br />
        &nbsp;&nbsp;<span className='cn'>&lt;span</span>
        <span className='cln'> class="</span>
        <span className='cn'>dot</span>
        <span className='cln'>"</span>&gt;<span className='cn'>&lt;/span&gt;</span><br />
        <span className='cn'>&lt;/div&gt;</span>
      </code>
    </pre >
  </>
);

export default DotHtmlSnippet